import { NavLink } from 'react-router-dom';

import { TextAlignName } from 'types';

import { HeadlineProps } from 'components/Headline';
import { IconName } from 'components/Icons';

import { StyledButtonIconProps, StyledButtonProps } from './Button.styles';
import * as S from './Button.styles';

type ButtonItem = {
  onClick?: () => void;
  asLink?: boolean;
  to?: string;
  // Forwarded to react-router's NavLink (asLink only) — without it, a
  // shorter sibling route (e.g. "/customers") matches as a path-segment
  // prefix of a longer one ("/customers/deleted") and both light up
  // ".active" at once. Only needed on a nav item whose own `to` is a
  // literal prefix of a sibling's.
  end?: boolean;
  type?: 'button' | 'submit';
  iconLeft?: IconName;
  iconRight?: IconName;
  testID?: string;
  textAlign?: TextAlignName;
  minWidth?: string;
};

export type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  StyledButtonProps &
  ButtonItem &
  Partial<HeadlineProps> &
  StyledButtonIconProps;

export function Button(props: ButtonProps): React.ReactElement {
  const {
    onClick,
    motive = 'm1',
    to,
    ref, // eslint-disable-line
    children,
    scale = 'xs',
    asLink,
    end,
    iconLeft = undefined,
    iconRight = undefined,
    disabled,
    fontWeight,
    textTransform,
    fontFamily = 'LFT Zeno',
    testID = 'button',
    textAlign = 'left',
    $iconSize = '1.2',
    minWidth,
    ...rest
  } = props;

  return (
    <S.Button
      data-testid={testID}
      disabled={disabled}
      to={disabled ? '#' : to}
      as={asLink ? NavLink : 'button'}
      end={asLink ? end : undefined}
      onClick={onClick}
      motive={motive}
      {...rest}
    >
      {iconLeft && <S.ButtonIconLeft $iconSize={$iconSize} name={iconLeft} scale={scale} />}

      {children && (
        <S.ButtonLabel
          tag="span"
          color="inherit"
          fontWeight={fontWeight}
          fontFamily={fontFamily}
          textTransform={textTransform}
          textAlign={textAlign}
          scale={scale}
          minWidth={minWidth}
        >
          {children}
        </S.ButtonLabel>
      )}

      {iconRight && <S.ButtonIconRight $iconSize={$iconSize} name={iconRight} scale={scale} />}
    </S.Button>
  );
}
